import { Component, computed, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTable } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { UserStore } from '../core/stores/base.store';
import { Profile } from '../core/models';
import { FuseConfirmationService } from '../core/services/confirmation/confirmation.service';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSortModule,
    MatToolbarModule,
    MatMenuModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css'
})
export class UsersComponent {
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<Profile>;
  
  private userStore = inject(UserStore);
  #fuseConfirmationService = inject(FuseConfirmationService);
  displayedColumns = ['id', 'uid', 'email', 'actions'];
  dataSource = computed(() => this.userStore.entities());
  loading = computed(() => this.userStore.loading());
  
  constructor(private router: Router) {}
  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.userStore.filterEntities({ filter: { search: filterValue } });
  }

  addUser() {
    this.userStore.selectEntity(null);
    this.router.navigate(['/users/add']);
  }

  impersonateUser(user: Profile) {
    // Implement impersonation logic
    const confirmation = this.#fuseConfirmationService.open({
      title: 'Impersonate User',
      message: `Are you sure you want to impersonate ${user.email}?`,
      actions: {
        confirm: {
          label: 'Impersonate'
        }
      }
    });

    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        // Here you would typically set some session state to indicate impersonation
        console.log(`Impersonating user: ${user.email}`);
        // You might want to redirect to the dashboard or another page as the impersonated user
        this.router.navigate(['/dashboard']);
      }
    });
  }

  deleteUser(user: Profile) {
    const confirmation = this.#fuseConfirmationService.open({
      title: 'Delete User',
      message: 'Are you sure you want to delete this user? This action cannot be undone!',
      actions: {
        confirm: {
          label: 'Delete'
        }
      }
    });

    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        this.userStore.delete(user);
        this.router.navigate(['/users']);
      }
    });
  }
}
